<template>
  <div class="field">
    <div class="control">
      <label class="label" v-if="to.label" :for="to.id ? to.id : null">{{
        to.label
      }}</label>
      <textarea
        :class="['textarea', { 'is-danger': hasError }, to.classes]"
        :id="to.id ? to.id : null"
        v-model="model[field.key]"
        @blur="onBlur"
        @focus="onFocus"
        @click="onClick"
        @change="onChange"
        @keyup="onKeyup"
        @keydown="onKeydown"
        v-formly-atts="to.atts"
      ></textarea>
      <error-display :form="form" :field="field.key"></error-display>
    </div>
  </div>
</template>

<script>
import baseField from "./baseField";

export default {
  mixins: [baseField]
};
</script>
